<script setup lang="ts">
import { HaskoningButton, HaskoningCard, HaskoningText } from "@haskoning/vue-component-library";

const sideloadDocumentationUrl =
  "https://learn.microsoft.com/office/dev/add-ins/testing/test-debug-office-add-ins#sideload-an-office-add-in-for-testing";
</script>

<template>
  <section class="d-flex align-center justify-center py-6 px-3" style="min-height: 100%">
    <HaskoningCard
      variant="outlined"
      width="360"
      max-width="360"
      min-width="0"
      class="message-side-load__card text-center"
    >
      <div
        class="d-inline-flex align-center justify-center mb-3 rounded-circle bg-primaryContainer text-onPrimaryContainer"
        style="width: 56px; height: 56px"
        aria-hidden="true"
      >
        <v-icon size="32">mdi-microsoft-excel</v-icon>
      </div>

      <HaskoningText id="message-side-load-title" as="h2" variant="title-medium" color="onSurface">
        Sideload the add-in in Excel
      </HaskoningText>

      <HaskoningText as="p" variant="body-medium" color="onSurfaceVariant" class="mt-2">
        Open this task pane from Excel to continue using Equation.
      </HaskoningText>

      <HaskoningButton
        :href="sideloadDocumentationUrl"
        target="_blank"
        rel="noopener noreferrer"
        variant="tonal"
        color="primary"
        size="small"
        append-icon="mdi-open-in-new"
        class="mt-5"
      >
        Sideload guide
      </HaskoningButton>
    </HaskoningCard>
  </section>
</template>

<style scoped>
.message-side-load__card :deep(.haskoning-card__content) {
  align-items: center;
}
</style>
